import { Component } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { DialogDataEnum } from '../../../enums/dialog.enum';

@Component({
  selector: 'bodyanalytics-signup-verify-cancel-dialog',
  imports: [MatDialogModule],
  templateUrl: './signup-verify-cancel-dialog.component.html',
  styleUrl: './signup-verify-cancel-dialog.component.scss',
})
export class SignupVerifyCancelDialogComponent {
  protected dialogEnum = DialogDataEnum;
}
